import axios from 'axios'
import Cookies from 'js-cookie'

const BASE_URI = process.env.VUE_APP_OMNI_CENTER_API

function authConfig() {
  const token = Cookies.get('Token')
  return {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  }
}

class ReservationService {
  async listStores(search) {
    const params = new URLSearchParams()
    if (search) params.set('search', search)
    params.set('limit', '50')
    const res = await axios.get(`${BASE_URI}/reservations/stores?${params.toString()}`, authConfig())
    return res.data
  }

  async list(filters) {
    const params = new URLSearchParams()
    Object.entries(filters || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return
      if (Array.isArray(v)) {
        if (v.length > 0) params.set(k, v.join(','))
      } else {
        params.set(k, String(v))
      }
    })
    const res = await axios.get(`${BASE_URI}/reservations?${params.toString()}`, authConfig())
    return res.data
  }

  async listWarehouses(storeId) {
    const params = new URLSearchParams()
    params.set('store_id', String(storeId))
    const res = await axios.get(`${BASE_URI}/reservations/warehouses?${params.toString()}`, authConfig())
    return res.data
  }

  async listProducts(filters) {
    const params = new URLSearchParams()
    Object.entries(filters || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return
      if (Array.isArray(v)) {
        if (v.length > 0) params.set(k, v.join(','))
      } else {
        params.set(k, String(v))
      }
    })
    const res = await axios.get(`${BASE_URI}/reservations/products?${params.toString()}`, authConfig())
    return res.data
  }

  async listReconcile(storeId) {
    const params = new URLSearchParams()
    if (storeId) params.set('store_id', String(storeId))
    const qs = params.toString()
    const url = `${BASE_URI}/reservations/reconcile${qs ? '?' + qs : ''}`
    const res = await axios.get(url, authConfig())
    return res.data
  }

  async reconcileFix({ store_id, direction, limit }) {
    const body = { store_id }
    if (direction) body.direction = direction
    if (limit) body.limit = limit
    const res = await axios.post(`${BASE_URI}/reservations/reconcile/fix`, body, authConfig())
    return res.data
  }
}

export default new ReservationService()
